<!-- 
程式：selfInputPropertyNumber.vue
功能：自行輸入國泰產險保單號碼
作者：i94005ws02 邱琬琪
完成：2020-11-03
-->
<template>
  <div class="tab-pane pt-3 active show">
    <div class="insurance-editor">
      <div class="col-12">
        <h4><span class="text-thin">分類：</span>自行輸入國泰產險保單號碼</h4>
        <div class="panel panel-form">
          <div
            style="height: 95px"
            class="panel insurance-item"
            v-for="(insure, i) in insurances"
            :key="`insure-item-${i}`"
          >
            <div class="col-1 no">{{ i + 1 }}</div>
            <div class="col-4 form-group form-group-inline">
              <label><span class="text-red">*</span>主被保人</label>
              <select
                :data-vv-name="`insuredID-${i}`"
                :class="{ 'is-invalid': errors.has(`insuredID-${i}`) }"
                v-validate="'required'"
                class="form-control form-control-inline form-wide"
                v-model="insure.insuredID"
                @change="
                  (e) =>
                    e.target.value === 'clientSearch'
                      ? panelCliendSearchOpen(i)
                      : ''
                "
                alt="ch"
              >
                <option value="">請選擇</option>
                <option
                  v-for="(item, index) in hasIDFamilies"
                  :key="index"
                  :value="item.csidno"
                >
                  {{ item.name | truncate }}
                </option>
                <option
                  v-for="(item, index) in options.customFamily"
                  :key="`customFamily${index}`"
                  :value="item.csidno"
                >
                  {{ item.name | truncate }}
                </option>
              </select>
              <div class="mt-2 text-right" v-if="errors.has(`insuredID-${i}`)">
                <label class="text-danger mr-5">請選擇主被保人</label>
              </div>
            </div>
            <div class="col-4 form-group form-group-inline">
              <label class="col-1 pr-0"
                ><span class="text-red">*</span>保單號碼</label
              >
              <input
                :data-vv-name="`plcno-${i}`"
                :data-vv-as="`保單號碼${insure.policyNumber}`"
                v-validate="{
                  required: true,
                  duplicate: insurances
                    .filter((x, j) => j !== i && x.policyNumber)
                    .map((x) => x.policyNumber)
                }"
                :class="{ 'is-invalid': errors.has(`plcno-${i}`) }"
                type="text"
                class="form-control form-control-inline"
                v-model="insure.policyNumber"
                maxlength="20"
                @input="checkPolicyNumber(i)"
              />
              <div class="mt-2 text-right" v-if="errors.has(`plcno-${i}`)">
                <label class="text-danger mr-4">
                  {{ errors.first(`plcno-${i}`) }}</label
                >
              </div>
            </div>
            <div class="action text-right">
              <button
                v-if="i > 0"
                type="button"
                class="btn btn-default form-control-inline"
                @click="deleteInsurance(i)"
              >
                刪除
              </button>
            </div>
          </div>
          <div
            class="panel insurance-item add text-center"
            role="button"
            @click="AddInsurance()"
          >
            <div class="content text-center">
              <i class="icon-add_new text-orange"></i>
              <span class="text ml-1">新增保單</span>
            </div>
          </div>
          <div class="error-block d-inline-block mb-0">
            <span class="error">
              ＊ <span class="text-black">注意事項</span>
            </span>
          </div>
          <div class="note pl-2">
            <p class="text-bold">請輸入「完整」國泰產險保單號碼。</p>
            <p class="text-bold">保單號碼最多20碼，不能輸入中文。</p>
            <p class="text-danger text-bold">
              ※主被保人需有ID，無ID客戶請先編輯客戶資料，輸入ID後才能建立保單。
              <br />
              ※請確認「客戶是否同意共銷」，系統僅能輸入同意共銷的國泰產險保單。
            </p>
          </div>
        </div>
        <div class="action mt-2 text-right">
          <a
            @click="cancelAdd()"
            type="button"
            role="button"
            class="btn btn-default"
            >取消</a
          >
          <a
            v-if="$route.query.canBackToMenu"
            @click="toMenu(prevRoute)"
            type="button"
            role="button"
            class="btn btn-default"
            >回上一步</a
          >
          <a
            @click="submit()"
            type="button"
            role="button"
            class="btn btn-primary"
            >確定</a
          >
        </div>
      </div>
    </div>
    <search-client-modal
      :open="clientSearchOpen"
      @submit="submitClient"
      @close="panelCliendSearchClose()"
    />
  </div>
</template>

<script>
import CommonMixin from "./Other";
import { commonMixin as GlobalMixins } from "@/mixins/common";
import SearchClientModal from "../../../components/SearchClientModal";
import {
  insertSelfInputPropertyNumber,
  getQuerySelfInputPropertyNumber,
  getRejectPropertyComarketing,
  getPolicyConsumerRelationship,
  getExistsSelfInputProperty
} from "@/service";

export default {
  mixins: [CommonMixin, GlobalMixins],
  components: { SearchClientModal },
  data() {
    return {
      clientSearchOpen: false,
      options: {
        customFamily: []
      },
      insurances: [
        {
          policyNumber: "",
          insuredID: "",
          pln: ""
        }
      ],
      panelIndex: null,
      prevRoute:''
    };
  },
  methods: {
    panelCliendSearchClose() {
      this.insurances[this.panelIndex].insuredID = "";
      this.panelClose("clientSearchOpen");
    },
    panelCliendSearchOpen(i) {
      this.panelIndex = i;
      this.panelOpen("clientSearchOpen");
    },
    //檢查保單號碼
    checkPolicyNumber(index) {
      this.insurances[index].policyNumber = this.insurances[
        index
      ].policyNumber.replace(/[^a-zA-Z0-9]+/g, "");
    },
    async AddInsurance() {
      if (await this.$validator.validateAll()) {
        this.insurances.push({
          policyNumber: "",
          insuredID: "",
          pln: ""
        });
      }
      this.registerHanlink();
    },
    async submit() {
      const user = JSON.parse(localStorage.userItems);
      this.getPln(user.agidno);//取得產險險別
      this.$validator
        .validateAll()
        .then((i) =>
          i ? this.insurances : Promise.reject("尚有欄位未填，請確認")
        )
        .then((i) =>
          this.getExists(
            user.agidno,
            user.agidno,
            i.map((v) => v.policyNumber)
          ).then((x) =>
            window._.isEmpty(x)
              ? i
              : Promise.reject(
                  `保單號碼${x
                    .map((v) => window._.get(v, "PLCNO", []))
                    .join("、")}:已存在於CRM`
                )
          )
        )
        .then((i) =>
          i.map((x) =>
            this.validInput(user.agidno, x.insuredID, x.policyNumber).then(
              (v) => ({
                ...x,
                result: v
              })
            )
          )
        )
        .then((i) => Promise.all(i))
        .then((i) =>
          i.every((x) => x.result)
            ? i
            : Promise.reject(
                i
                  .filter((i) => !i.result)
                  .map((i) => i.policyNumber)
                  .join("、") +
                  "：請確認「被保人」、「保單號碼」是否正確，以及【被保人是否同意共銷】，系統僅能輸入同意共銷的國泰產險保單。"
              )
        )
        .then((i) =>
          insertSelfInputPropertyNumber(this.$store.state.userInfo.id, i)
        )
        .then((i) =>
          window._.get(i, "header.status", 0) === "200"
            ? "新增成功"
            : Promise.reject(window._.get(i, "header.message", "新增失敗"))
        )
        .then((i) => {
          //判斷是否回是保健
          if(this.prevRoute){
            this.toMenu(this.prevRoute)
            this.$toast.info({ title: i });
          }else{
            this.$toast.info({ title: i });
            this.$router.push({
              name: "policyInfo-edit-list",
              query: {
                modify: this.insurances.map((x) => x.policyNumber).join(",")
              }
            });
          }

        })
        .catch((i) => {
          this.$toast.info({ title: i });
        });
    },
    // 查詢自行輸入國泰產險保單
    getExists(userId, agent, policyNumbers) {
      return getExistsSelfInputProperty(
        userId,
        agent,
        policyNumbers
      ).then((res) => window._.get(res, "body", []));
    },
    //查詢自行輸入國泰產壽保單 & 是否同意共同行銷
    async validInput(userId, insuredID, policyNumber) {
      const conditions = await Promise.all([
        this.getSelfMsg(userId, insuredID, policyNumber),
        this.isPropertyComarketing(userId, insuredID),
        this.isPolicyConsumerRelationship(userId, insuredID, policyNumber)
      ]);
      return conditions.every((x) => x);
    },
    // 查詢保單與客戶關係
    async isPolicyConsumerRelationship(userId, insuredID, policyNumber) {
      const res = await getPolicyConsumerRelationship(
        userId,
        insuredID,
        policyNumber
      );
      return (
        res.header && res.header.status === "200" && !window._.isEmpty(res.body)
      );
    },
    // 是否同意產險共銷
    async isPropertyComarketing(userId, insuredID) {
      const res = await getRejectPropertyComarketing(userId, insuredID);
      return (
        // 查無拒絕共銷紀錄
        res.header && res.header.status === "200" && window._.isEmpty(res.body)
      );
    },
    async getSelfMsg(userId, insuredID, policyNumber) {
      const result = await getQuerySelfInputPropertyNumber(
        userId,
        insuredID,
        policyNumber
      );
      if (result.header && result.header.status === "200") {
        let selfData = result.body.dataList;
        return !!selfData;
      }
      return false;
    },
    async getPln(agidno) {
        for(let i in this.insurances){
          const result = await getQuerySelfInputPropertyNumber(
            agidno,
            this.insurances[i].insuredID,
            this.insurances[i].policyNumber
          );
          if (result.header && result.header.status === "200") {
            let selfData = result.body.dataList;
            this.insurances[i].pln = selfData.PLN;
          }
        }
    },
    deleteInsurance(i) {
      this.insurances.splice(i, 1);
    },
    submitClient(member) {
      this.options.customFamily.push({
        csidno: member.id,
        name: member.name
      });
      this.insurances[this.panelIndex].insuredID = member.id;
      this.clientSearchOpen = false;
    }
  },
  computed: {
    hasIDFamilies() {
      console.log(this.options)
      return this.options.families.filter(
        (x) => !window._.startsWith(x.csidno, "~")
      );
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
};
</script>
